import axios from 'axios'
import { employeeAllocationApiConfig, AllowedHttpMethods } from '../../apiList'
import { getAuthenticatedRequestConfig } from '../../../../utils/apiUtils'
import {
  EmployeeAllocationReportProps,
  EmployeeAllocationReportType,
  ProjectUnderEmployees,
  ProjectUnderEmployeesProps,
  UpdateEmployeeAllocationProject,
  EmployeeExportAllocationReport,
} from '../../../../types/ProjectManagement/EmployeeAllocation/employeeAllocationTypes'

const getEmployeeAllocationReport = async (
  props: EmployeeAllocationReportProps,
): Promise<EmployeeAllocationReportType> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: employeeAllocationApiConfig.getEmployeeAllocationReport,
    method: AllowedHttpMethods.get,
    params: {
      Billingtype: props.Billingtype ?? '',
      EmployeeStatus: props.EmployeeStatus ?? '',
      dateSelection: props.dateSelection ?? '',
      departmentNames: props.departmentNames.length
        ? props.departmentNames?.join(',')
        : '',
      employeeName: props.employeeName ?? '',
      endIndex: props.endIndex ?? 20,
      enddate: props.enddate ?? '',
      firstIndex: props.firstIndex ?? 0,
      startdate: props.startdate ?? '',
      technology: props.technology ?? '',
      jobType: props.jobType ?? '',
      country: props.country ?? '',
    },
  })

  const response = await axios(requestConfig)
  return response.data
}

const projectUnderEmployeesReport = async (
  props: ProjectUnderEmployeesProps,
): Promise<ProjectUnderEmployees[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: employeeAllocationApiConfig.projectUnderEmployees,
    method: AllowedHttpMethods.get,
    params: {
      dateSelection: props.dateSelection ?? '',
      employeeid: props.employeeid ?? '',
      enddate: props.enddate ?? '',
      isAllocated: props.isAllocated ?? '',
      isBillale: props.isBillale ?? '',
      startdate: props.startdate ?? '',
    },
  })
  const response = await axios(requestConfig)
  return response.data
}

const updateEmployeeAllocationProject = async (
  updateEmployeeAllocation: UpdateEmployeeAllocationProject,
): Promise<number | undefined> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: employeeAllocationApiConfig.updateEmployeeAllocateProject,
    method: AllowedHttpMethods.post,
    data: updateEmployeeAllocation,
  })
  const response = await axios(requestConfig)
  return response.data
}

const exportEmployeeAllocationData = async (
  props: EmployeeExportAllocationReport,
): Promise<Blob | undefined> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: employeeAllocationApiConfig.downloadEmployeeAllocationList,
    method: AllowedHttpMethods.get,
    params: {
      id: props.id ?? '',
      startIndex: props.startIndex ?? '',
      endIndex: props.endIndex ?? '',
      empName: props.empName ?? '',
      technology: props.technology ?? '',
      isbillable: props.isbillable ?? '',
      isAllocated: props.isAllocated ?? '',
      startdate: props.startdate ?? '',
      lastdate: props.lastdate ?? '',
      departmentNames: props.departmentNames ?? '',
      dateSelection: props.dateSelection ?? '',
      token: localStorage.getItem('token') ?? '',
      jobType: props.jobType ?? '',
      country: props.country ?? '',
    },
    responseType: 'blob',
  })
  const response = await axios(requestConfig)
  return response.data
}
const exportEmployeeAllocationListData = async (
  props: EmployeeExportAllocationReport,
): Promise<Blob | undefined> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: employeeAllocationApiConfig.downloadExportEmployeeAllocationList,
    method: AllowedHttpMethods.get,
    params: {
      id: props.id ?? '',
      startIndex: props.startIndex ?? '',
      endIndex: props.endIndex ?? '',
      empName: props.empName ?? '',
      technology: props.technology ?? '',
      isbillable: props.isbillable ?? '',
      isAllocated: props.isAllocated ?? '',
      startdate: props.startdate ?? '',
      lastdate: props.lastdate ?? '',
      departmentNames: props.departmentNames ?? '',
      dateSelection: props.dateSelection ?? '',
      token: localStorage.getItem('token') ?? '',
      jobType: props.jobType ?? '',
      country: props.country ?? '',
    },
    responseType: 'blob',
  })
  const response = await axios(requestConfig)
  return response.data
}

const employeeAllocationReportApi = {
  getEmployeeAllocationReport,
  projectUnderEmployeesReport,
  updateEmployeeAllocationProject,
  exportEmployeeAllocationData,
  exportEmployeeAllocationListData,
}

export default employeeAllocationReportApi
